/*=========== HERO ANIMATION ===========*/

document.addEventListener("DOMContentLoaded", () => {
  /*=========== Elements ===========*/
  const hero = document.querySelector(".hero-section");
  const phone = document.querySelector(".hero-phone");
  const floatingItems = document.querySelectorAll(".floating, .metal-ball");
  const button = document.querySelector(".theme-btn");

  /*=========== Parallax Mouse Effect ===========*/

  hero.addEventListener("mousemove", (e) => {
    const x = e.clientX / window.innerWidth;
    const y = e.clientY / window.innerHeight;
    phone.style.transform = `translate(${x * 20}px, ${y * 20}px)`;
    floatingItems.forEach((item, index) => {
      const speed = (index + 1) * 12;
      item.style.transform = `translate(${x * speed}px, ${y * speed}px)`;
    });
  });

  hero.addEventListener("mouseleave", () => {
    phone.style.transform = "";
    floatingItems.forEach((item) => {
      item.style.transform = "";
    });
  });

  /*=========== Button Hover Effect ===========*/

  button.addEventListener("mouseenter", () => {
    button.style.transform = "translateY(-6px) scale(1.04)";
  });

  button.addEventListener("mouseleave", () => {
    button.style.transform = "translateY(0) scale(1)";
  });

  /*=========== Button Ripple ===========*/

  button.addEventListener("click", function (e) {
    const ripple = document.createElement("span");
    ripple.classList.add("ripple");
    this.appendChild(ripple);
    const x = e.offsetX;
    const y = e.offsetY;
    ripple.style.left = x + "px";
    ripple.style.top = y + "px";
    setTimeout(() => {
      ripple.remove();
    }, 700);
  });

  /*=========== Scroll Reveal Animation ===========*/

  const revealItems = document.querySelectorAll(
    ".hero-badge," +
      ".hero-title," +
      ".hero-description," +
      ".feature-item," +
      ".theme-btn," +
      ".hero-phone",
  );

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("show");
        }
      });
    },
    { threshold: 0.2 },
  );

  revealItems.forEach((item) => {
    observer.observe(item);
  });

  /*=========== Floating Animation Delay ===========*/
  floatingItems.forEach((item, index) => {
    item.style.animationDelay = `${index * 0.5}s`;
  });
});

/*=========== Brand SLIDER ===========*/

function initBrandSlider() {

    document.querySelectorAll(".brand-slider").forEach((slider) => {

        if (slider.swiper) {
            slider.swiper.destroy(true, true);
        }

        const section = slider.closest(".brand-section");

        new Swiper(slider, {

            slidesPerView: 2,
            spaceBetween: 15,
            speed: 800,
            grabCursor: true,

            loop: true,
            loopedSlides: 12,
            loopAdditionalSlides: 12,
            watchOverflow: false,
            centeredSlides: false,

            // navigation: {
            //     nextEl: section.querySelector(".brand-next"),
            //     prevEl: section.querySelector(".brand-prev"),
            // },

            autoplay: {
                delay: 1000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
            },

            observer: true,
            observeParents: true,
            observeSlideChildren: true,

            breakpoints: {

                576: {
                    slidesPerView: 2,
                    spaceBetween: 15
                },

                768: {
                    slidesPerView: 3,
                    spaceBetween: 20
                },

                992: {
                    slidesPerView: 4,
                    spaceBetween: 20
                },

                1200: {
                    slidesPerView: 5,
                    spaceBetween: 25
                },

                1400: {
                    slidesPerView: 6,
                    spaceBetween: 30
                }

            }

        });

    });

}

document.addEventListener("DOMContentLoaded", initBrandSlider);

document.addEventListener("shopify:section:load", initBrandSlider);

document.addEventListener("shopify:section:reorder", initBrandSlider);

/*=========== Category SLIDER ===========*/
new Swiper(".category-slider", {
    slidesPerView: 2,
    spaceBetween: 20,
    loop: true,
    speed: 700,

    autoplay: {
      delay: 1500,
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    },

    breakpoints: {
        576: {
            slidesPerView: 2
        },
        768: {
            slidesPerView: 3
        },
        992: {
            slidesPerView: 4
        },
        1200: {
            slidesPerView: 4
        }
    }
});

/*=========== PRODUCT COLLECTION SLIDER Start ===========*/

/*=========================================
SPARE PARTS BRAND SLIDER
=========================================*/

document.addEventListener("DOMContentLoaded", function () {

  document.querySelectorAll(".spare-parts-section .swiper").forEach(function (swiper) {

    const totalSlides = swiper.querySelectorAll(".swiper-slide").length;

    new Swiper(swiper, {
      slidesPerView: 3,
      spaceBetween: 15,
      speed: 700,

      // Enable loop only if enough slides exist
      loop: totalSlides > 3,

      // Autoplay
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },

      // navigation: {
      //   nextEl: swiper.querySelector(".swiper-button-next"),
      //   prevEl: swiper.querySelector(".swiper-button-prev"),
      // },

      breakpoints: {
        0: {
          slidesPerView: 1,
        },
        576: {
          slidesPerView: 2,
        },
        992: {
          slidesPerView: 2,
        },
      },
    });

  });

});
/*=========== PRODUCT COLLECTION SLIDER End ===========*/

/*=========================================
Counter Js
=========================================*/

document.addEventListener("DOMContentLoaded", function () {
  const counters = document.querySelectorAll(".counter");

  const options = {
    threshold: 0.4,
  };

  const observer = new IntersectionObserver(function (entries, observer) {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;

      const counter = entry.target;

      const target = parseFloat(counter.dataset.target);

      const duration = 2000;

      const startTime = performance.now();

      function animate(currentTime) {
        const progress = Math.min((currentTime - startTime) / duration, 1);

        const value = target * progress;

        if (Number.isInteger(target)) {
          counter.textContent = Math.floor(value).toLocaleString();
        } else {
          counter.textContent = value.toFixed(1);
        }

        if (progress < 1) {
          requestAnimationFrame(animate);
        } else {
          if (Number.isInteger(target)) {
            counter.textContent = target.toLocaleString();
          } else {
            counter.textContent = target.toFixed(1);
          }
        }
      }

      requestAnimationFrame(animate);

      observer.unobserve(counter);
    });
  }, options);

  counters.forEach((counter) => observer.observe(counter));
});

/*=========================================
Footer Animation Js
=========================================*/

document.addEventListener("DOMContentLoaded", function () {
  const items = document.querySelectorAll(".footer-about, .footer-widget");

  const observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add("show");
        }
      });
    },
    {
      threshold: 0.2,
    },
  );

  items.forEach(function (item) {
    observer.observe(item);
  });
});



document.addEventListener("DOMContentLoaded", function () {

    /*=========================================
        PRICE RANGE
    =========================================*/

    const range = document.querySelector(".form-range");

    if (range) {

        const labels = document.querySelectorAll(".price-slider span");

        function updatePrice() {

            labels[1].textContent = "₹" + Number(range.value).toLocaleString();

        }

        updatePrice();

        range.addEventListener("input", updatePrice);

    }

    /*=========================================
        GRID / LIST VIEW
    =========================================*/

    const gridBtn = document.querySelector(".view-buttons .btn-view:first-child");
    const listBtn = document.querySelector(".view-buttons .btn-view:last-child");
    const productWrapper = document.querySelector(".shop-section .row.g-4");

    if (gridBtn && listBtn && productWrapper) {

        gridBtn.addEventListener("click", function () {

            gridBtn.classList.add("active");
            listBtn.classList.remove("active");

            productWrapper.querySelectorAll("[class*='col-']").forEach(function (item) {

                item.className = "col-xl-3 col-lg-4 col-md-6";

            });

            document.querySelectorAll(".product-card").forEach(function (card) {

                card.classList.remove("list-view");

            });

        });

        listBtn.addEventListener("click", function () {

            listBtn.classList.add("active");
            gridBtn.classList.remove("active");

            productWrapper.querySelectorAll("[class*='col-']").forEach(function (item) {

                item.className = "col-12";

            });

            document.querySelectorAll(".product-card").forEach(function (card) {

                card.classList.add("list-view");

            });

        });

    }

    /*=========================================
        WISHLIST
    =========================================*/

    document.querySelectorAll(".wishlist-btn").forEach(function (button) {

        button.addEventListener("click", function () {

            this.classList.toggle("active");

            const icon = this.querySelector("i");

            if (icon.classList.contains("bi-heart")) {

                icon.classList.remove("bi-heart");
                icon.classList.add("bi-heart-fill");

            } else {

                icon.classList.remove("bi-heart-fill");
                icon.classList.add("bi-heart");

            }

        });

    });

    /*=========================================
        PRODUCT HOVER IMAGE
    =========================================*/

    document.querySelectorAll(".product-card").forEach(function (card) {

        card.addEventListener("mouseenter", function () {

            const img = this.querySelector("img");

            if (img) {

                img.style.transform = "scale(1.08)";

            }

        });

        card.addEventListener("mouseleave", function () {

            const img = this.querySelector("img");

            if (img) {

                img.style.transform = "scale(1)";

            }

        });

    });

});



document.addEventListener("DOMContentLoaded", function(){

    const copyContent = (desktopId, mobileId)=>{

        const desktop = document.querySelector(desktopId);

        const mobile = document.querySelector(mobileId);

        if(desktop && mobile){

            mobile.innerHTML = desktop.innerHTML;

        }

    }

    copyContent(
        "#desktop-category-filter",
        "#mobile-category-content"
    );

    copyContent(
        "#desktop-brand-filter",
        "#mobile-brand-content"
    );

    copyContent(
        "#desktop-type-filter",
        "#mobile-type-content"
    );

    copyContent(
        "#desktop-price-filter",
        "#mobile-price-content"
    );

});


const bottomBar = document.querySelector(".mobile-bottom-bar");

const filterCanvas = document.getElementById("mobileFilter");
const sortCanvas = document.getElementById("mobileSort");

if(filterCanvas){

    filterCanvas.addEventListener("show.bs.offcanvas", function(){

        bottomBar.style.display = "none";

    });

    filterCanvas.addEventListener("hidden.bs.offcanvas", function(){

        bottomBar.style.display = "flex";

    });

}

if(sortCanvas){

    sortCanvas.addEventListener("show.bs.offcanvas", function(){

        bottomBar.style.display = "none";

    });

    sortCanvas.addEventListener("hidden.bs.offcanvas", function(){

        bottomBar.style.display = "flex";

    });

}